<template>
  <div class="banner bg-cover bg-center"
  :style="{ 'background-image': 'url(' + require('@/assets/images/banner.png') + ')' }">
    <div class="slogan">
      <span class="slogan-1">taiwan bus+</span><br>
      <span class="slogan-2">台 灣 公 車 動 態</span><br>
      <span class="slogan-3">時 刻 查 詢 系 統</span>
    </div>
  </div>
</template>
